import { Action } from 'redux';

import * as actions from './actions';

import { ErrorAction } from '../common/error-action';
import { LoadingAction } from '../common/loading-action';
import { TourEvent } from '@common/types/traclink/tour-event';
import { NewTourEvent } from '@common/types/traclink/new-tour-event';
import { TracLinkState } from './state';

export class ResetEventDrafts implements Action {
  readonly type = actions.RESET_EVENT_DRAFTS;
}

export class CreateEventDraft implements Action {
  readonly type = actions.CREATE_EVENT_DRAFT;

  constructor(
    public event: TourEvent,
    public draftKey: keyof TracLinkState['tourEventDrafts']
  ) {}
}

export class ResetTracLinkStore implements Action {
  readonly type = actions.RESET_TRACLINK_STORE;
}

export class GetTourEvents implements LoadingAction {
  readonly type = actions.GET_TOUR_EVENTS;
  readonly isLoading = true;

  constructor(public ownerId: string) {}
}

export class GetTourEventsSuccess implements LoadingAction {
  readonly type = actions.GET_TOUR_EVENTS_SUCCESS;
  readonly isLoading = false;

  constructor(
    public results: TourEvent[],
    public drafts?: TracLinkState['tourEventDrafts']
  ) {}
}

export class GetTourEventsError implements ErrorAction {
  readonly type = actions.GET_TOUR_EVENTS_ERROR;
  readonly isLoading = false;
  readonly isError = true;

  constructor(public code: string) {}
}

export class AddTourEvent implements LoadingAction {
  readonly type = actions.ADD_TOUR_EVENT;
  readonly isLoading = true;

  constructor(public newTourEvent: NewTourEvent) {}
}

export class AddTourEventSuccess implements LoadingAction {
  readonly type = actions.ADD_TOUR_EVENT_SUCCESS;
  readonly isLoading = false;

  constructor(public results: TourEvent) {}
}

export class AddTourEventError implements ErrorAction {
  readonly type = actions.ADD_TOUR_EVENT_ERROR;
  readonly isLoading = false;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateTourEvent implements LoadingAction {
  readonly type = actions.UPDATE_TOUR_EVENT;
  readonly isLoading = true;

  constructor(public tourEvent: TourEvent) {}
}

export class UpdateTourEventSuccess implements LoadingAction {
  readonly type = actions.UPDATE_TOUR_EVENT_SUCCESS;
  readonly isLoading = false;

  constructor(public results: TourEvent) {}
}

export class UpdateTourEventError implements ErrorAction {
  readonly type = actions.UPDATE_TOUR_EVENT_ERROR;
  readonly isLoading = false;
  readonly isError = true;

  constructor(public code: string) {}
}

export class DeleteTourEvent implements LoadingAction {
  readonly type = actions.DELETE_TOUR_EVENT;
  readonly isLoading = true;

  constructor(public ownerId: string, public tourId: string) {}
}

export class DeleteTourEventSuccess implements LoadingAction {
  readonly type = actions.DELETE_TOUR_EVENT_SUCCESS;
  readonly isLoading = false;

  constructor(public tourId: string) {}
}

export class DeleteTourEventError implements ErrorAction {
  readonly type = actions.DELETE_TOUR_EVENT_ERROR;
  readonly isLoading = false;
  readonly isError = true;

  constructor(public code: string) {}
}

export type TracLinkActions =
  | GetTourEvents
  | GetTourEventsSuccess
  | GetTourEventsError
  | AddTourEvent
  | AddTourEventSuccess
  | AddTourEventError
  | UpdateTourEvent
  | UpdateTourEventSuccess
  | UpdateTourEventError
  | DeleteTourEvent
  | DeleteTourEventSuccess
  | DeleteTourEventError
  | CreateEventDraft
  | ResetEventDrafts;
